import { createApp, h } from "vue";
import Bulk from "./components/Bulk";
import BulkCreator from "./components/BulkCreator";
import MaisonAgendas from "./components/MaisonAgendas";
import SlotEditForm from "./components/SlotEditForm";
import AgendaModal from "./components/AgendaModal";
import AgendaRemoveModal from "./components/AgendaRemoveModal";
import vSelect from "vue-select";
import { plugin, defaultConfig } from "@formkit/vue";

const app = createApp({
    render: () => h(Bulk),
});

app.use(
    plugin,
    defaultConfig({
        config: {
            classes: {
                input: "form-control",
                wrapper: "form-group",
            },
        },
    })
);

app.component("VSelect", vSelect);
app.component("BulkCreator", BulkCreator);
app.component("MaisonAgendas", MaisonAgendas);
app.component("SlotEditForm", SlotEditForm);
app.component("AgendaModal", AgendaModal);
app.component("AgendaRemoveModal", AgendaRemoveModal);

app.mount("#bulk");
